(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var topicCards = document.querySelectorAll('.faq-topic-card');
    var sidebarBtns = document.querySelectorAll('.faq-sidebar__btn');
    var groups = document.querySelectorAll('.faq-group');

    function switchCat(cat) {
      topicCards.forEach(function(c) {
        c.classList.toggle('faq-topic-card--active', c.dataset.cat === cat);
      });
      sidebarBtns.forEach(function(b) {
        b.classList.toggle('faq-sidebar__btn--active', b.dataset.cat === cat);
      });
      groups.forEach(function(g) {
        var show = g.dataset.cat === cat;
        g.classList.toggle('faq-group--hidden', !show);
        if (show) {
          var first = g.querySelector('.faq-item');
          if (first) first.setAttribute('open', '');
        }
      });
    }

    topicCards.forEach(function(card) {
      card.addEventListener('click', function() { switchCat(this.dataset.cat); });
    });
    sidebarBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { switchCat(this.dataset.cat); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {

  var form = document.getElementById('cart-form');
  if (!form) return;

  function updateItem(key, qty) {
    var item = document.querySelector('[data-key="' + key + '"].cart-item');
    if (item) item.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Update line price
      var lineItem = cart.items.find(function(i) { return i.key === key; });
      var linePriceEl = document.getElementById('line-price-' + key);
      if (lineItem && linePriceEl) {
        linePriceEl.textContent = formatMoney(lineItem.final_line_price);
      }
      // Update totals
      var subtotalEl = document.getElementById('cart-subtotal');
      var totalEl = document.getElementById('cart-total');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      // Remove row if qty = 0
      if (qty === 0 && item) {
        item.style.transition = 'opacity 250ms, max-height 350ms';
        item.style.opacity = '0';
        item.style.overflow = 'hidden';
        setTimeout(function() {
          item.style.maxHeight = '0';
          item.style.padding = '0';
          setTimeout(function() { item.remove(); checkEmpty(cart); }, 350);
        }, 250);
      } else if (item) {
        item.classList.remove('is-loading');
      }
      // Update header cart count if bubble exists
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) bubble.textContent = cart.item_count > 0 ? cart.item_count : '';
    })
    .catch(function() {
      if (item) item.classList.remove('is-loading');
    });
  }

  function formatMoney(cents) {
    return 'R ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function checkEmpty(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  // Plus / Minus buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-qty__btn');
    if (!btn) return;
    var key = btn.dataset.key;
    var input = document.querySelector('.cart-qty__input[data-key="' + key + '"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var newQty = btn.classList.contains('cart-qty__plus') ? current + 1 : Math.max(0, current - 1);
    input.value = newQty;
    updateItem(key, newQty);
  });

  // Manual input change
  document.addEventListener('change', function(e) {
    var input = e.target.closest('.cart-qty__input');
    if (!input) return;
    var newQty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = newQty;
    updateItem(input.dataset.key, newQty);
  });

  // Remove button
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-item__remove');
    if (!btn) return;
    updateItem(btn.dataset.key, 0);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function() {
  function init() {

    /* Gallery */
    var main = document.getElementById('pdp-gallery-main');
    var slides = main ? main.querySelectorAll('.pdp-gallery__slide') : [];
    var thumbs = document.querySelectorAll('.pdp-gallery__thumb');
    var currentSlide = 0;
    function goTo(idx) {
      if (!slides.length) return;
      slides[currentSlide].classList.remove('pdp-gallery__slide--active');
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.remove('pdp-gallery__thumb--active');
      currentSlide = (idx + slides.length) % slides.length;
      slides[currentSlide].classList.add('pdp-gallery__slide--active');
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('pdp-gallery__thumb--active');
    }
    var prev = main && main.querySelector('.pdp-gallery__arrow--prev');
    var next = main && main.querySelector('.pdp-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function() { goTo(currentSlide - 1); });
    if (next) next.addEventListener('click', function() { goTo(currentSlide + 1); });
    thumbs.forEach(function(t) { t.addEventListener('click', function() { goTo(parseInt(this.dataset.index)); }); });

    /* Qty stepper */
    var minus = document.getElementById('pdp-qty-minus');
    var plus = document.getElementById('pdp-qty-plus');
    var qtyInput = document.getElementById('pdp-qty-input');
    if (minus && plus && qtyInput) {
      minus.addEventListener('click', function() { var v = parseInt(qtyInput.value)||1; if(v>1) qtyInput.value=v-1; });
      plus.addEventListener('click', function() { var v = parseInt(qtyInput.value)||1; if(v<99) qtyInput.value=v+1; });
    }

    /* Sticky bar */
    var stickyBar = document.getElementById('pdp-sticky-bar');
    var atcBtn = document.getElementById('pdp-atc');
    var stickyAtcBtn = document.getElementById('pdp-sticky-atc');
    var form = document.getElementById('pdp-form');
    if (stickyBar && atcBtn) {
      stickyBar.removeAttribute('aria-hidden');
      var atcVisible = false;

      function updateStickyBar() {
        var scrollBottom = window.scrollY + window.innerHeight;
        var docHeight = document.documentElement.scrollHeight;
        var nearBottom = scrollBottom >= docHeight - 80;
        var show = !atcVisible && !nearBottom;
        stickyBar.classList.toggle('pdp-sticky-bar--visible', show);
        stickyBar.style.visibility = show ? '' : 'hidden';
      }

      var atcObserver = new IntersectionObserver(function(entries) {
        atcVisible = entries[0].isIntersecting;
        updateStickyBar();
      }, { threshold: 0.5 });
      atcObserver.observe(atcBtn);

      window.addEventListener('scroll', updateStickyBar, { passive: true });
      updateStickyBar();
    }
    /* AJAX ATC — click handler, opens drawer */
    function addToCart() {
      var btn = document.getElementById('pdp-atc');
      var formEl = document.getElementById('pdp-form');
      var variantId = formEl ? formEl.dataset.variantId : null;
      var qty = parseInt((document.getElementById('pdp-qty-input') || {}).value, 10) || 1;
      if (!variantId) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = 'ADD TO CART <span class="pdp-atc-btn__circle" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'ADD TO CART'; }
      });
    }

    if (atcBtn) atcBtn.addEventListener('click', addToCart);
    if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', addToCart);

    /* Related quick-add */
    document.querySelectorAll('.pdp-related-card__atc').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var id = this.dataset.variantId;
        if (!id) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
